module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAQCAYAAADAvYV+AAAAAXNSR0IArs4c6QAAAHxJREFUKBVjnL9sxQ4Ghv8cDFgAIxPjyvjw8BmMjIz/QdIsQIXuWNSBhf7/Y+pYsGqV/////zeCNDDhUggWZ/z7g0FMbAdUAyN+xUAdiY6OYA2LVq70Y5y/bDnYPXhtgEoSNBnZkFHFgzA0WBiYGC0Z/mNPosjuZWBk/AEASNglJqdMg0UAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./resources/images/n-contracts_1x.png
// module id = 2311
// module chunks = 0